import type { WarehouseRef } from "./types.ts";

/*
 * Склады деятельности для выбора в «Видати і списати» и заявке. Заглушка до
 * GET склада: имена складов это данные арендатора (docs/plan.md, «Склады и
 * путь изделия»), с сервером список придёт оттуда.
 */
export const ACTIVITY_WAREHOUSES: WarehouseRef[] = [
  { code: "SER", name: "Серія", activity: true },
  { code: "BPK", name: "БПАК", activity: true },
  { code: "RND", name: "R&D", activity: true },
  { code: "SRV", name: "Ремонт", activity: true },
  { code: "FG", name: "Готова продукція", activity: true },
];
